const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20414",
    d: "M0 0h19v19H0z",
    style: {
      fill: "#f3f3f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20415",
    d: "M1 1h8.261v8.261H1z",
    transform: "translate(-.174 -.174)",
    style: {
      fill: "#f35325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20416",
    d: "M12 1h8.261v8.261H12z",
    transform: "translate(-2.087 -.174)",
    style: {
      fill: "#81bc06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20417",
    d: "M1 12h8.261v8.261H1z",
    transform: "translate(-.174 -2.087)",
    style: {
      fill: "#05a6f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20418",
    d: "M12 12h8.261v8.261H12z",
    transform: "translate(-2.087 -2.087)",
    style: {
      fill: "#ffba08"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/microsoft_logo.62e593961843fd58a32980760d86b816.svg";
export { ForwardRef as ReactComponent };